import OrbitModuleHeader from '../../shared/hub/OrbitModuleHeader.jsx';
import ClientsPage from './pages/ClientsPage.jsx';

// One page for now, so no nav tabs. `moduleId` is passed even though it suppresses the
// workspace selector rather than showing one: the registry's clientScoped:false is what
// decides that, and naming the module here is an honest declaration rather than an omission
// that would later read as a bug.
export default function ClientManagementApp() {
  return (
    <div style={{ minHeight: '100vh', background: 'var(--paper)' }}>
      <OrbitModuleHeader title="Client Management" moduleId="client-management" />
      <ClientsPage />
    </div>
  );
}
